import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const reportIssueSlice = createApi({
  reducerPath: "reportIssueSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: commonBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token;
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getReportIssues: builder.query({
      query: ({ page = 1, limit = 10, search = "" }) =>
        `/report-issues?page=${page}&limit=${limit}&search=${search}`,
    }),
    updateReportStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/report-issues/${id}/status`,
        method: "PATCH",
        body: { status },
      }),
    }),
  }),
});

export const { useGetReportIssuesQuery, useUpdateReportStatusMutation } = reportIssueSlice;
